<template>
    <v-row v-if="!$store.getters.progress" style="height: max-content; pb-offset" class="ma-0">
        <v-col cols="12" class="pa-4">
            <v-card class="flex pa-0 round-card background-2">
                <v-card-title class="pa-3" style="position: relative">
				    <p class="pl-2 pl-xl-3">Notifiche</p>
                    <v-spacer></v-spacer>
                    <!-- absolute: compare sulla linea di separazione senza spostare il contenuto sotto -->
                    <v-progress-linear :active="loading" indeterminate color="primary" height="3" absolute bottom></v-progress-linear>
                </v-card-title>
                <v-divider></v-divider>

                <v-col lg="10" offset-lg="1" md="10" offset-md="1" cols="12" class="pt-0">
                    <v-row class="px-3 pt-4 ma-0" align="center">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Cerca"
                            clearable
                            hide-details
                            outlined
                            dense
                        ></v-text-field>
                        <v-btn-toggle
                            v-model="filters.status"
                            mandatory
                            dense
                            color="primary"
                            background-color="background-2"
                            class="notifications-status"
                            :class="$vuetify.breakpoint.mdAndUp ? 'ml-3' : 'notifications-status--block mt-3'">
                            <v-btn v-for="s in status" :key="s.value" :value="s.value">
                                {{ s.text }}
                                <span v-if="s.value === 'unread' && unreadCount" class="notifications-status__count ml-2">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
                            </v-btn>
                        </v-btn-toggle>
                    </v-row>

                    <!-- Le azioni sulla selezione compaiono solo quando c'è qualcosa selezionato -->
                    <v-row class="px-3 pt-2 ma-0" align="center" style="min-height: 52px">
                        <v-checkbox
                            v-model="allSelected"
                            :indeterminate="selected.length > 0 && !allSelected"
                            hide-details
                            color="primary"
                            class="mt-0 pt-0 mr-4"
                        ></v-checkbox>

                        <template v-if="selected.length">
                            <span class="fs14 mr-2">{{ selected.length }} {{ selected.length === 1 ? 'selezionata' : 'selezionate' }}</span>
                            <!-- Le azioni stanno sempre a destra, dove c'è "Segna tutte come lette" senza selezione -->
                            <v-spacer></v-spacer>
                            <template v-if="$vuetify.breakpoint.mdAndUp">
                                <v-btn text color="primary" @click="changeSelectedStatus('read')">Segna come lette</v-btn>
                                <v-btn text color="primary" @click="changeSelectedStatus('unread')">Segna come da leggere</v-btn>
                            </template>
                            <template v-else>
                                <v-btn icon color="primary" aria-label="Segna come lette" @click="changeSelectedStatus('read')">
                                    <v-icon>mdi-email-open-outline</v-icon>
                                </v-btn>
                                <v-btn icon color="primary" aria-label="Segna come da leggere" @click="changeSelectedStatus('unread')">
                                    <v-icon>mdi-email-outline</v-icon>
                                </v-btn>
                            </template>
                        </template>
                        <template v-else>
                            <v-spacer></v-spacer>
                            <v-btn v-if="filters.status !== 'read' && unreadCount" text color="primary" @click="markAllAsRead">
                                <v-icon left>mdi-check-all</v-icon>
                                {{ search ? 'Segna i risultati come letti' : 'Segna tutte come lette' }}
                            </v-btn>
                        </template>
                    </v-row>


                    <v-list two-line class="w100p pt-0 background-2">
                        <v-data-iterator
                            :items="notifications"
                            :options.sync="pagination"
                            :server-items-length="totalItems"
                            :footer-props="{
                                'items-per-page-options': [5, 10, 25, 50]
                            }">

                            <template v-slot:no-data>
                                <v-divider></v-divider>
                                <v-card class="background-2 fs12i pt-4 pb-4 mx-4" elevation="0">
                                    <v-card-text class="text-center py-8">{{ search ? 'Nessuna notifica trovata' : 'Nessuna notifica' }}</v-card-text>
                                </v-card>
                                <v-divider></v-divider>
                            </template>

                            <template v-slot:item="{index, item}">
                                <v-row class="ma-0" align="center" :key="item.id">
                                    <v-col class="align-center pa-0" lg="12" md="12" cols="12" >
                                        <v-list-item
                                            class="notification-row cursor-pointer"
                                            ripple
                                            :key="index">
                                            <template v-if="!item.read_at">
                                                <div class="notification-row__tint primary"></div>
                                                <div class="notification-row__bar primary"></div>
                                            </template>
                                            <v-list-item-action>
                                                <v-checkbox :key="item.id" color="primary" :value="item.id" v-model="selected" hide-details></v-checkbox>
                                            </v-list-item-action>
                                            <v-list-item-avatar v-if="item.data.type == 'task'">
                                                <v-avatar v-if="avatars[item.data.user_id]"
                                                    class="custom-avatar"
                                                    :size="34" 
                                                    v-ripple
                                                    :style="{'background-image': 'url(' + avatars[item.data.user_id] + ')'}">
                                                </v-avatar>
                                                <v-avatar v-else :class="$eventBusUtility.bgColor(item.data.user_id)" :size="34">
                                                    <span class="white--text fs14" v-if="item.data.creator">{{ item.data.creator.charAt(0) }}</span>
                                                </v-avatar>
                                            </v-list-item-avatar>

                                            <v-list-item-avatar v-else-if="item.data.type == 'maillog'">
                                                <v-avatar
                                                    size="34px" 
                                                    style="min-width: 34px; width: 34px; height:34px; border-radius: 50px; margin:auto"
                                                    class="primary">
                                                    <v-icon class="fs20i" color="white">drafts</v-icon>
                                                </v-avatar>
                                            </v-list-item-avatar>
                                            
                                            <v-list-item-avatar v-else-if="item.data.type == 'quotation-signed'">
                                                <v-avatar
                                                    size="34px" 
                                                    style="min-width: 34px; width: 34px; height:34px; border-radius: 50px; margin:auto"
                                                    class="primary">
                                                    <v-icon class="fs20i" color="white">mdi-file-check-outline</v-icon>
                                                </v-avatar>
                                            </v-list-item-avatar>

                                            <v-list-item-avatar v-else>
                                                <v-avatar v-if="avatars[item.data.user_id]"
                                                    class="custom-avatar"
                                                    :size="34" 
                                                    v-ripple
                                                    :style="{'background-image': 'url(' + avatars[item.data.user_id] + ')'}">
                                                </v-avatar>
                                                <v-avatar v-else :class="$eventBusUtility.bgColor(item.data.user_id)" :size="34">
                                                    <span class="white--text fs14" v-if="item.data.creator">{{ item.data.creator.charAt(0) }}</span>
                                                </v-avatar>
                                            </v-list-item-avatar>

                                            <v-list-item-content class="pr-2 pl-4" @click.stop="handleNotificationClick(item)" @mousedown.middle.stop.prevent="openInNewTab(item.data.modelDef + '-show', item.data.modelDefId)">
                                                <v-list-item-title class="notification-row__headline fs14i" :class="{'text--secondary': item.read_at, 'notification-row__headline--compact': !$vuetify.breakpoint.mdAndUp}"><span :class="item.read_at ? 'font-weight-medium' : 'font-weight-bold'">{{ item.data.title }}</span>{{ subtitleSeparator(item.data.subtitle) }}{{ item.data.subtitle }}</v-list-item-title>
                                                <v-list-item-subtitle v-if="item.data.text" class="fs13i">{{ item.data.text }}</v-list-item-subtitle>
                                                <!-- Su mobile l'orario sta sotto il testo per lasciare spazio alla frase -->
                                                <v-list-item-subtitle v-if="!$vuetify.breakpoint.mdAndUp" class="fs12i">{{ formatNotificationTime(item.created_at) }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action class="pr-4">
                                                <v-list-item-action-text v-if="$vuetify.breakpoint.mdAndUp" class="fs12i">{{ formatNotificationTime(item.created_at) }}</v-list-item-action-text>
                                                <v-tooltip v-if="item.read_at === null" top class="fs12i">
            								        <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on" @click.stop="loading = true; $eventBusUtility.changeNotificationStatus([item.id], 'read')" class="fs20i" color="grey lighten-1">email</v-icon>
            								        </template>
                                                    <span class="fs11i">Segna come letta</span>
                                                </v-tooltip>
                                                <v-tooltip v-else top class="fs12i">
            								        <template v-slot:activator="{ on }">
                                                        <v-icon v-on="on" @click.stop="loading = true; $eventBusUtility.changeNotificationStatus([item.id], 'unread')" class="fs20i" color="grey lighten-1">drafts</v-icon>
            								        </template>
                                                    <span class="fs11i">Segna come da legere</span>
                                                </v-tooltip>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                                <v-divider inset :key="index"></v-divider>
                            </template>

                            <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
                                Da {{ pageStart }} a {{ pageStop }} di {{ itemsLength }}
                            </template>
                        </v-data-iterator>                            
                    </v-list>
                </v-col>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'notifications',
        props: {},
        data() {
            return {
                notifications: [],
                pagination: {'itemsPerPage': 10},
                totalItems: 0,
                selected: [],
                isSelected : false,
                filters: {status: 'all'},
                search: '',
                status: [{value: 'all', text:'Tutte'}, {value: 'unread', text:'Da leggere'}, {value: 'read', text: 'Lette'}],
                avatars: [],
                loading: false,
            }
        },

        computed: {
            autoReadEnabled() {
                return !this.$store.getters.getSettingByModel('viewing', 'notification_disable_auto_read')
            },

            // Stesso conteggio del badge della campanella: non lette, archivi esclusi
            unreadCount() {
                return this.$store.getters.notificationsCount
            },

            allSelected: {
                get() {
                    return this.notifications.length > 0 && this.selected.length === this.notifications.length
                },
                set(value) {
                    this.selected = value ? this.notifications.map(n => n.id) : []
                }
            }
        },

        watch: {
            pagination: {
                handler(newVal, oldVal) {
                    this.initialize()
                },
                deep: true,
            },

            filters: {
                handler() {
                    this.pagination.page = 1
                    this.initialize()
                },
                deep: true,
            }
        },

        methods: {

            changeSelectedStatus(status) {
                this.loading = true
                this.$eventBusUtility.changeNotificationStatus(this.selected, status)
            },

            markAllAsRead() {
                this.loading = true
                this.axios.put('notifications/', {status: 'read', all: true, search: this.search, exclude_archives: true}).then(response => {
                    const count = response.data.count
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: count === 1 ? '1 notifica segnata come letta' : count + ' notifiche segnate come lette',
                        value: true,
                        color: 'success'
                    })
                    this.$eventBusUtility.$emit('updateNotifications', true)
                }, () => {
                    this.loading = false
                    this.$store.commit('setSnackbarError')
                })
            },

            // "ti ha assegnato un ticket" continua la frase del titolo, "Questa mail è stata letta" è una frase a sé
            subtitleSeparator(subtitle) {
                if (!subtitle) {
                    return ''
                }
                const first = subtitle.charAt(0)
                return first === first.toLowerCase() ? ' ' : ' — '
            },

            // Se non si è in prima pagina basta spostarsi lì: ci pensa il watcher di pagination a ricaricare
            applySearch() {
                if (this.pagination.page > 1) {
                    this.pagination.page = 1
                } else {
                    this.initialize()
                }
            },

            handleNotificationClick(notification) {
                if (!notification.read_at && this.autoReadEnabled) {
                    this.$store.commit('REMOVE_NOTIFICATION', notification.id)
                    this.$eventBusUtility.changeNotificationStatus([notification.id], 'read')
                }
                if (notification.data.modelDef === 'whatsappconversations') {
                    this.$router.push({
                        path: '/whatsapp',
                        query: { conversation_id: notification.data.modelDefId }
                    }).catch(() => {})
                } else if (notification.data.modelDef === 'event') {
                    this.$router.push({
                        path: '/calendar',
                        query: { event_id: notification.data.modelDefId }
                    }).catch(() => {})
                } else if (notification.data.modelDef === 'calendar') {
                    this.$router.push({
                        path: '/calendar'
                    }).catch(() => {})
                } else if (notification.data.type === 'google_account') {
                    this.$router.push({
                        path: '/profile/calendars'
                    }).catch(() => {})
                } else if (notification.data.modelDef === 'edocuments' && notification.data.type === 'import_edocuments') {
                    // resoconto del lotto (prima apriva la show di un edocument con l'id dell'utente)
                    this.$router.push({
                        path: '/invoices/edocuments',
                        query: notification.data.report ? { import_report: notification.data.report } : {}
                    }).catch(() => {})
                } else {
                    let routeName = notification.data.modelDef + '-show'
                    try {
                        let resolved = this.$router.resolve({ name: routeName, params: { id: notification.data.modelDefId } })
                        if (resolved && resolved.route.name !== undefined) {
                            this.$router.push({ name: routeName, params: { id: notification.data.modelDefId } }).catch(() => {})
                        }
                    } catch (e) {
                        // route non esistente
                    }
                }
            },

            openInNewTab(routeName, params) {
                const route = this.$router.resolve({ name: routeName, params: { id: params } })
                window.open(route.href, '_blank')
            },

            formatNotificationTime(date) {
                if (date) {
                    return moment(date).startOf('second').fromNow()
                } else {
                    return ''
                }
            },

            initialize() {
                this.loading = true
                let dataObject = {
                    page: this.pagination.page,
                    per_page: this.pagination.itemsPerPage,
                    filters: this.filters,
                    search: this.search,
                    exclude_archives: true
                }
                this.axios.post('notifications/', dataObject).then(response => {
                    this.notifications = response.data.notifications.data
                    this.avatars = response.data.avatars
                    this.totalItems = response.data.notifications.total
                    this.selected = []
                    this.loading = false
                }, response => {
                    // error callback
                    this.loading = false
                })
            },
        },

        created() {
            this.$store.commit('endProgress')
        },

        mounted() {
            this._debouncedSearch = _.debounce(this.applySearch, 700)
            this.$watch('search', this._debouncedSearch)

            this._updateNotificationsHandler = () => {
                this.initialize()
            }
            this.$eventBusUtility.$on('updateNotifications', this._updateNotificationsHandler)
        },

        beforeDestroy() {
            this._debouncedSearch.cancel()
			this.$eventBusUtility.$off('updateNotifications', this._updateNotificationsHandler)
		}

    }
</script>

<style >
    .notification-row {
        min-height: 64px;
        padding-left: 12px;
    }

    /* Sfondo e barra delle non lette: prendono il colore primario del tenant dalla classe .primary */
    .notification-row__tint,
    .notification-row__bar {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        pointer-events: none;
    }

    .notification-row__tint {
        right: 0;
        opacity: .08;
    }

    .notification-row__bar {
        width: 3px;
    }

    .notification-row__headline {
        white-space: normal;
        line-height: 1.35 !important;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .notification-row__headline--compact {
        -webkit-line-clamp: 3;
        line-clamp: 3;
    }

    /* Stessa altezza e stesso bordo del campo Cerca outlined dense che le sta accanto */
    .v-btn-toggle.notifications-status > .v-btn.v-btn {
        height: 40px;
        background-color: transparent;
    }

    .theme--light .notifications-status > .v-btn.v-btn {
        border-color: rgba(0, 0, 0, .38) !important;
    }

    .theme--dark .notifications-status > .v-btn.v-btn {
        border-color: rgba(255, 255, 255, .24) !important;
    }

    .notifications-status--block {
        width: 100%;
    }

    .notifications-status--block > .v-btn.v-btn {
        flex: 1 1 auto;
        min-width: 0;
        padding: 0 8px;
        letter-spacing: normal;
    }

    .notifications-status__count {
        min-width: 20px;
        padding: 0 6px;
        border-radius: 10px;
        font-size: 11px;
        line-height: 18px;
        background: rgba(0, 0, 0, .08);
    }

    .theme--dark .notifications-status__count {
        background: rgba(255, 255, 255, .16);
    }

    #list-item-notification {
        height: 54px;
        padding-left: 12px;
    }  

    #list-item-notification .v-list-item__title {
        font-size: 12px !important;
    }  

    #list-item-header  {
        padding-left: 0px !important;
        height: 54px;

    }
    .v-list-item__action {
        min-width: 48px;
    }
    .v-list-item__avatar {
        min-width: 48px;
    }
</style>
